export default __webpack_public_path__ + "static/media/Saly.71b43c41.png";